<template>
  <div :class="classList">
    <div
      v-if="overlay"
      class="a-loading-spinner__overlay"
      :class="{ 'a-loading-spinner__overlay--login': login }">
    </div>
    <svg class="a-loading-spinner__loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:none;display:block;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="50" cy="50" r="32" stroke-width="3" stroke="#0098ce" stroke-dasharray="50 50" fill="none" stroke-linecap="round">
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.3" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
      </circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'VLoadingSpinner',
  introduction: 'Spinner animation which can overlay an entire element.',
  props: {
    overlay: {
      type: Boolean,
      default: true,
      note: 'If true an obscuring background is added which fills the parent element.',
    },
    size: {
      type: String,
      default: 'large',
      note: 'Sizes the element (can be "large" or "medium").',
    },
    login: {
      type: Boolean,
      default: false,
      note: 'To be removed.',
    },
  },
  computed: {
    classList() {
      const defaultClass = 'a-loading-spinner';
      const size = this.size ? ` a-loading-spinner--${this.size}` : '';
      const overlay = !this.overlay ? ' a-loading-spinner--no-overlay' : '';
      return defaultClass + size + overlay;
    },
  },
};
</script>

<style scoped>
.a-loading-spinner {
  border-radius: inherit;
}

.a-loading-spinner__overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 2;
  top: 0px;
  left: 0px;
  border-radius: inherit;
}

.a-loading-spinner__overlay--login {
  top: 0;
  left: 0;
  border-radius: 3px;
}

.a-loading-spinner__loader {
  transition: 1s ease;
  z-index: 2;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
  animation: fadeInAfterDelay 0.5s;
}

.a-loading-spinner--no-overlay .a-loading-spinner__loader {
  position: initial;
  margin: 50px auto 0;
}

.a-loading-spinner--large .a-loading-spinner__loader {
  width: 150px;
  height: 150px;
}

.a-loading-spinner--medium .a-loading-spinner__loader {
  width: 60px;
  height: 60px;
}

@keyframes fadeInAfterDelay {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
